import React from 'react';
import { FadeIn } from './FadeIn';
export function TomosSection() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1',
    desc: 'Historia Clínica, Anamnesis & Marco Legal AR'
  }, {
    icon: '📗',
    title: 'Tomo 2',
    desc: 'Educación Alimentaria & Material para Pacientes'
  }, {
    icon: '📙',
    title: 'Tomo 3',
    desc: 'Recetarios Estacionales Argentinos (+80 recetas)'
  }, {
    icon: '📕',
    title: 'Tomo 4',
    desc: 'Patologías Prevalentes: DBT2, HTA, Celiaquía, HGNA, SII y más'
  }, {
    icon: '📓',
    title: 'Tomo 5',
    desc: 'Deporte, Suplementación & Antropometría'
  }, {
    icon: '📔',
    title: 'Tomo 6',
    desc: 'Marketing, Gestión del Consultorio & Scripts WhatsApp'
  }];
  return <section className="py-12 px-4 max-w-5xl mx-auto" data-id="element-333">
      <FadeIn data-id="element-334">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-335">
          <span className="text-4xl" data-id="element-336">📚</span> LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-337">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-338">
            <div className="bg-gray-900 border border-gray-800 hover:border-green-500/50 transition-colors rounded-xl p-6 h-full flex flex-col" data-id="element-339">
              <div className="text-4xl mb-4" data-id="element-340">{tomo.icon}</div>
              <h3 className="text-xl font-bold text-green-400 mb-2" data-id="element-341">
                {tomo.title}
              </h3>
              <p className="text-gray-300 font-medium leading-relaxed flex-grow" data-id="element-342">
                {tomo.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}